import React, { useEffect, useState } from "react";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { baseurladdress } from "../baseurl";
import axios from 'axios';

function LeaveLevelSetup() {
    const accesstoken = localStorage.getItem("token");
    const Swal = require('sweetalert2')

    const [leaveLevels, setLeaveLevels] = useState([]);
    const [roles, setRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        level: "",
        role: "",
        description: ""
    });

    const showToast = (icon, title) => {
        Swal.fire({ toast: true, position: "top-end", icon, title, showConfirmButton: false, timer: 2000 });
    };

    const fetchLevels = () => {
        axios.get(baseurladdress + "getallapprovallevels", { headers: { Authorization: `Bearer ${accesstoken}` } })
            .then((res) => setLeaveLevels(Array.isArray(res.data.response) ? res.data.response : []))
            .catch(() => setLeaveLevels([]));
    };

    const fetchRoles = () => {
        axios.get(baseurladdress + "findallactiveroles", { headers: { Authorization: `Bearer ${accesstoken}` } })
            .then((res) => setRoles(Array.isArray(res.data.response) ? res.data.response : []))
            .catch(() => setRoles([]));
    };

    useEffect(() => {
        fetchLevels();
        fetchRoles();
    }, []);

    const openAddModal = () => {
        setIsEditing(false);
        setEditId(null);
        setFormData({ level: "", role: "", description: "" });
        setShowModal(true);
    };

    const openEditModal = (item) => {
        setIsEditing(true);
        setEditId(item.Llevel_id);
        setFormData({
            level: item.Llevel_priority ?? "",
            role: (item.Llevel_rolename || "").trim(),
            description: item.Llevel_description || ""
        });
        fetchRoles();
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setIsEditing(false);
        setEditId(null);
        setFormData({ level: "", role: "", description: "" });
    };

    const handleSave = () => {
        if (formData.level === "" || formData.level === null) {
            showToast("warning", "Please enter priority.");
            return;
        }

        if (!String(formData.level).trim()) {
            showToast("warning", "Please enter priority.");
            return;
        }

        if (!formData.role.trim()) {
            showToast("warning", "Please enter role name.");
            return;
        }

        if (isEditing) {
            axios.put(baseurladdress + "updateapprovallevel/" + editId,
                {
                    Llevel_priority: Number(formData.level),
                    Llevel_rolename: formData.role.trim(),
                    Llevel_description: formData.description.trim()
                },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            )
            .then((res) => {
                if (res.data.status === "success") {
                    showToast("success", "Level updated.");
                    closeModal();
                    fetchLevels();
                }
            })
            .catch(() => showToast("error", "Server error."));
        } else {
            axios.post(baseurladdress + "saveapprovallevel",
                {
                    Llevel_priority: Number(formData.level),
                    Llevel_rolename: formData.role.trim(),
                    Llevel_description: formData.description.trim()
                },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            )
            .then((res) => {
                if (res.data.status === "success") {
                    showToast("success", "Level added.");
                    closeModal();
                    fetchLevels();
                }
            })
            .catch(() => showToast("error", "Server error."));
        }
    };

    const handleDelete = (item) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`${baseurladdress}deleteapprovallevel/${item.Llevel_id}`, {}, { headers: { Authorization: `Bearer ${accesstoken}` } })
                    .then((res) => {
                        if (res.data.status === "deleted") {
                            showToast("success", "Deleted.");
                            setLeaveLevels((prev) => prev.filter((d) => d.Llevel_id !== item.Llevel_id));
                        } else {
                            showToast("info", res.data.message || "Cannot delete.");
                        }
                    })
                    .catch(() => showToast("error", "Server error."));
            }
        });
    };

    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h6 className="card-title">Leave Levels Setup</h6>
                                    <button className="btn plus-icon d-flex align-items-center" onClick={openAddModal}>
                                        <i className="fa fa-plus-circle text-success"></i>
                                        <span style={{ fontSize: "0.7rem", padding: "5px", color: "black" }}>Add Level</span>
                                    </button>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-responsive-sm">
                                            <thead>
                                                <tr>
                                                    <th>Priority</th>
                                                    <th>Role Name</th>
                                                    <th>Description</th>
                                                    <th style={{ width: "80px", textAlign: "center" }}>Edit</th>
                                                    <th style={{ width: "80px", textAlign: "center" }}>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {leaveLevels.length > 0 ? (
                                                    leaveLevels.map((item, index) => (
                                                        <tr key={item.Llevel_id || index}>
                                                            <td>{item.Llevel_priority ?? ""}</td>
                                                            <td>{item.Llevel_rolename || ""}</td>
                                                            <td>{item.Llevel_description || ""}</td>
                                                            <td className="text-center">
                                                                <i className="fa fa-edit text-primary"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => openEditModal(item)}></i>
                                                            </td>
                                                            <td className="text-center">
                                                                <i className="fa fa-trash text-danger"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => handleDelete(item)}></i>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr><td colSpan="5" className="text-center" style={{ color: "#999" }}>No data found</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditing ? "Edit Leave Level" : "Add Leave Level"}</h5>
                                <button
                                    type="button"
                                    className="btn btn-link p-0 text-dark text-decoration-none"
                                    onClick={closeModal}
                                    aria-label="Close"
                                    style={{ fontSize: "1.1rem", lineHeight: 1 }}
                                >
                                    X
                                </button>
                            </div>
                            <div className="modal-body">
                                <label>Priority</label>
                                <input type="number" className="form-control mb-3"
                                    placeholder="Enter priority"
                                    value={formData.level}
                                    onChange={(e) => setFormData({ ...formData, level: e.target.value })} />

                                <label>Role Name</label>
                                <select className="form-control mb-3"
                                    value={formData.role}
                                    onChange={(e) => setFormData({ ...formData, role: e.target.value })}>
                                    <option value="">-- Select Role --</option>
                                    {roles.map((role) => (
                                        <option key={role.role_id} value={(role.role_name || "").trim()}>
                                            {(role.role_name || "").trim()}
                                        </option>
                                    ))}
                                </select>

                                <label>Description</label>
                                <textarea className="form-control" rows="3"
                                    placeholder="Enter description"
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}></textarea>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeModal}>Cancel</button>
                                <button className="btn btn-primary" onClick={handleSave}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default LeaveLevelSetup;
